import { useDecision } from '@optimizely/react-sdk'
import dynamic from 'next/dynamic'
import { useTranslation } from 'next-i18next'
import { AdvertisingSlot } from 'react-advertising'
import { useTheme } from 'styled-components'

import {
  FiltersAccordion,
  FiltersAccordionOrigin,
} from '@/components/srp/filters/FiltersAccordion/FiltersAccordion'
import {
  FiltersSidebarPanel,
  FiltersSidebarTitle,
  SkyscraperAdSlotContainer,
} from '@/components/srp/filters/FiltersSidebar/styled'
import { FiltersDivider } from '@/components/srp/filters/styled'
import { SrpLoading } from '@/components/srp/srp-loading'
import { GPT_COMPONENT_ID } from '@/features/advertisement/constants/adSlots'
import { GA_SAVE_SEARCH_TYPES } from '@/lib/ga/constants/ga'
import { FEATURE_FLAG } from '@/lib/optimizely'

const SaveSearchChipButton = dynamic(
  () => import('@/components/srp/save-search-chip').then((mod) => mod.SaveSearchChipButton),
  { ssr: false }
)

export type FiltersSidebarProps = {
  isMobileForAds?: boolean
  isLoadingFilters?: boolean
}

export const FiltersSidebar = ({ isMobileForAds, isLoadingFilters }: FiltersSidebarProps) => {
  const { t } = useTranslation('srp')
  const { colors } = useTheme()
  const [srpQuickFilterPillsDecision] = useDecision(FEATURE_FLAG.SRP_QUICK_FILTERS_PILLS)
  const [saveSearchWithinFiltersDecision] = useDecision(FEATURE_FLAG.SAVED_SEARCH_WITHIN_FILTERS)
  const areQuickFilterPillsActive =
    srpQuickFilterPillsDecision?.enabled && srpQuickFilterPillsDecision?.variationKey === 'b'

  return (
    <div>
      <FiltersSidebarPanel data-testid="srp-desktop-filter">
        {saveSearchWithinFiltersDecision.enabled && (
          <SaveSearchChipButton eventTrackingSource={GA_SAVE_SEARCH_TYPES.btn} />
        )}
        {!areQuickFilterPillsActive ? (
          <>
            <FiltersSidebarTitle color={colors.grey.primary} as="h2">
              {t('filters.title')}
            </FiltersSidebarTitle>
            <FiltersDivider />
          </>
        ) : null}

        {isLoadingFilters ? (
          <SrpLoading
            variant={areQuickFilterPillsActive ? 'sidebar-filter-simplified' : 'sidebar-filter'}
          />
        ) : (
          <FiltersAccordion
            isSimplified={areQuickFilterPillsActive}
            origin={FiltersAccordionOrigin.SIDE_PANEL}
          />
        )}
      </FiltersSidebarPanel>

      {!isMobileForAds && (
        <SkyscraperAdSlotContainer areQuickFilterPillsActive={areQuickFilterPillsActive}>
          <AdvertisingSlot
            id={GPT_COMPONENT_ID.SKYSCRAPER}
            data-testid={GPT_COMPONENT_ID.SKYSCRAPER}
          />
        </SkyscraperAdSlotContainer>
      )}
    </div>
  )
}
